import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {
    Col, Row, Form, FormGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input
} from 'reactstrap';

import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoginRequest } from '../../../redux/Action/Auth/LoginAction'
import Teacher from '../../../assets/Images/TeacherLogo.png'
import Assistant from '../../../assets/Images/AssistantLogo.png'
import Student from '../../../assets/Images/StudentLogo.png'
import Parent from '../../../assets/Images/ParentLogo.png'
import RenderField from '../../../components/Fields/fields'
import String from '../../../assets/Locales/teacher_locales.js';
import { Inputs } from './inputSettings'
import { visit } from '../../../redux/Action/Auth/LoginAction'
import validate from './validation';
import LoadingBar from 'react-redux-loading-bar'
import './login.css'
import axios from "axios";
import { API_ENDPOINT } from '../../../AppConfig';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            nestedModal: false,
            closeAll: false,
            userType: null,
            subLevels: [],
            sublevel: null,
            userTypeErr: false,
            sublevelErr: false,
            Levels: [],
            level: null,
            levelErr: false,
            RedirectTo: false

        };

        this.toggle = this.toggle.bind(this);
        this.toggleNested = this.toggleNested.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
    }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleNested() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll: false
        });
    }

    toggleAll() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll: true
        });
    }
    chahnageLang(lang) {
        localStorage.setItem('Language', lang);

    }
    onSubmit = (values) => {
        console.log("valuesssss", values)
        this.props.LoginRequest(values, localStorage.getItem('Language'))
    }
    componentWillMount() {
        this.GetLevel()
    }
    GetLevel() {
        let url = `${API_ENDPOINT}/levels`
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                // console.log("GETSUB res", response.data.data)
                this.setState({ Levels: response.data.data })
            }).catch(error => {
                // console.log("GETSUB error:", error.response);
            })
    }

    GetSubLevel(Id) {
        let url = `${API_ENDPOINT}/sublevels?level=${Id}`
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                // console.log("GETSUB res", response.data.data)
                this.setState({ subLevels: response.data.data })
            }).catch(error => {
                // console.log("GETSUB error:", error.response);
            })
    }
    viewAsVisitor() {
        if(this.state.level&&!this.state.sublevel){
            this.setState({sublevelErr:true})
            return null
        }
        if(!this.state.level){
            this.setState({levelErr:true})
            return null
        }
        
        this.props.visit('VISITOR', this.state.sublevel)
        this.setState({ RedirectTo: true })
    }
    render() {

        if ((this.props.token && !this.props.sucessRegister) || this.state.RedirectTo) {
            return (
                <Redirect to="/home" />
            )
        } else if (this.props.confirm) {
            return (
                <Redirect to="/verifyaccount" />
            )
        }
        let lang = localStorage.getItem("Language");
        // console.log("lang", lang)
        if (lang) {
            // console.log("lang in if", lang)
            String.setLanguage(localStorage.getItem("Language"));
        } else {
            // console.log("lang in else", lang)
            lang = "ar"
            String.setLanguage("ar");
        }
        const { handleSubmit, submitting } = this.props
        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "black" }} />
                </div>
                <div className="login-content" style={{ direction: lang === 'ar' ? 'rtl' : 'ltr' }}>
                    <div className="login-container">
                        <Row className="login-image-content">
                            <Col md="12" className="big-img">
                                <img src={Teacher} alt="Teacher" />
                            </Col>
                            <Col md="12" className="small-imgs">
                                <img src={Student} alt="Student" />
                                <img src={Parent} alt="Parent" />
                                <img src={Assistant} alt="Assistant" />
                            </Col>
                            <Col md="12" id="login-links">
                                {/* style={{ float: lang === "ar" ? "left" : "right",marginLeft: lang === "ar" ? "2%" : "" }} */}
                                {/* style={{ float: lang === "ar" ? "left" : "right",marginLeft: lang === "ar" ? "2%" : "" }} */}
                                <Link className="visitor-link" onClick={this.toggle}>
                                    <i className="fa fa-eye mx-2"></i>
                                    {String.viewAsVisitor}
                                </Link>
                                <Link className="visitor-link mx-3" onClick={() => { this.chahnageLang(lang === "ar" ? "en" : "ar") }}>
                                    {lang === "ar" ? "English" : "Arabic"}
                                </Link>


                            </Col>
                        </Row>
                        <Row >
                            <Col md="6" lg="4" style={{ margin: 'auto', marginTop: '2%' }}>
                                <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    {
                                        Inputs.map((row, index) => {
                                            return (
                                                <FormGroup>
                                                    {
                                                        row.map((element, index) => {
                                                            return (
                                                                <Field
                                                                    lang={lang}
                                                                    type={element.type}
                                                                    name={element.name}
                                                                    component={RenderField}
                                                                    label={lang === "ar" ? element.label.ar : element.label.en}
                                                                    placeholder={element.placeholder}
                                                                    options={element.options}
                                                                    optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                                // title={lang === "ar" ? element.title.ar : element.title.en}
                                                                />
                                                            )
                                                        })

                                                    }
                                                </FormGroup>
                                            )
                                        })
                                    }
                                    <Col md="12" className="login-submit-Btn" style={{ marginTop: '10%' }} id="loginBtn">
                                        <Button type="submit" className="btn submitBtn" disabled={submitting}> {String.loginBtn}  </Button>
                                    </Col>
                                </Form>
                                <Row className="login-ques mt-4 mb-4">

                                    <Col lg="7" md="7" sm="7" xs="7" className="p-0 headingMobile" style={{ textAlign: localStorage.getItem("Language") === "ar" || localStorage.getItem("Language") === "" ? "right" : "" }}>
                                        <h6> {String.signupQues}
                                            <Link to='/registeration' className="login-click"> {String.signup} </Link>
                                        </h6>
                                    </Col>

                                    <Col lg="5" md="5" sm="5" xs="5" className="p-0 headingMobile" style={{ textAlign: localStorage.getItem("Language") === "en" || localStorage.getItem("Language") === "" ? "right" : "" }}>
                                        <Link to='/forget-password'
                                            className={lang === "ar" ? " login-forget-ar login-click" : " login-forget-en login-click"} > <h6 > {String.forgetQues}  </h6> </Link>
                                    </Col>


                                </Row>

                            </Col>
                        </Row>
                    </div>
                </div >
                {/* <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button> */}
                 <Modal style={{ marginTop: "10%" }} isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} >
                    <ModalHeader style={{ display: "block",textAlign:"end", backgroundColor: "#FEC85E", color: "#fff" }} className=""  toggle={this.toggle}>
                        
                        
                        {String.chooseLevel}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <Col lg="12" md="12">
                                <FormGroup>
                                    <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر المرحلة" : "Choose level"} </Label>
                                    <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                        onChange={(e) => {
                                            this.GetSubLevel(e.target.value)
                                            this.setState({ level: e.target.value, levelErr: false })
                                        }}>
                                        <option> {lang === 'ar' ? " المرحلة" : "Level"} </option>
                                        {this.state.Levels.map((items, index) => (
                                            <option value={items.id}> {items.name} </option>
                                        ))}

                                    </Input>
                                </FormGroup>
                                {this.state.levelErr &&
                                    <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                        style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار المرحلة  ' : 'Please choose level'} </h6>
                                }

                            </Col>
                            {this.state.level &&
                                <Col lg="12" md="12">
                                    <FormGroup>
                                        <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر الصف" : "Choose sub level"} </Label>
                                        <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                            onChange={(e) => this.setState({ sublevel: e.target.value, sublevelErr: false })}>
                                            <option> {lang === 'ar' ? " الصف" : " sub level"} </option>
                                            {this.state.subLevels.map((items, index) => (
                                                <option value={items.id}> {items.name} </option>
                                            ))}

                                        </Input>
                                    </FormGroup>
                                    {this.state.sublevelErr &&
                                        <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                            style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار الصف  ' : 'Please choose sub level'} </h6>
                                    }

                                </Col>

                            }
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="footerVisitor" onClick={() => { this.viewAsVisitor() }}>{String.Continue}</Button>
                    </ModalFooter>
                </Modal>
            </div >

        )
    }
}
const mapStateToProps = state => {
    return {
        token: state.login.token,
        confirm: state.login.confirm,
        verified: state.login.verified,
        sucessRegister: state.login.sucessRegister
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        LoginRequest,
        visit
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(Login));